import React from 'react'
import { useTranslation } from 'react-i18next'
import i18n from '@src/i18n'

import Hero from '../../components/Hero'
import Article from '../../components/Article'
import Section from '../../components/Section'

export interface AccountsReceivableProps {}

const HERO_IMAGE = '/paywalls/accounts-receivable/hero.png'

const ARTICLES = [
  {
    title: i18n.t('paywalls:accountsReceivable.articles.invoice.title'),
    text: i18n.t('paywalls:accountsReceivable.articles.invoice.text'),
    image: '/paywalls/accounts-receivable/invoice.png',
  },
  {
    title: i18n.t('paywalls:accountsReceivable.articles.approval.title'),
    text: i18n.t('paywalls:accountsReceivable.articles.approval.text'),
    image: '/paywalls/accounts-receivable/approval.png',
  },
  {
    title: i18n.t('paywalls:accountsReceivable.articles.reporting.title'),
    text: i18n.t('paywalls:accountsReceivable.articles.reporting.text'),
    image: '/paywalls/accounts-receivable/reporting.png',
  },
  {
    title: i18n.t('paywalls:accountsReceivable.articles.transfer.title'),
    text: i18n.t('paywalls:accountsReceivable.articles.transfer.text'),
    image: '/paywalls/accounts-receivable/transfer.png',
  },
]

export const AccountsReceivable: React.FC<AccountsReceivableProps> = () => {
  const { t } = useTranslation('paywalls', { keyPrefix: 'accountsReceivable' })
  return (
    <>
      <Hero title={t('hero.title')} image={HERO_IMAGE} subtitle={t('hero.subtitle')} />
      <Section title={t('section.title')} text={t('section.text')} />
      <div className="flex flex-col gap-6">
        {ARTICLES.map((article, index) => (
          <Article
            key={article.title}
            title={article.title}
            image={article.image}
            text={article.text}
            hasActionButtons={index === ARTICLES.length - 1}
          />
        ))}
      </div>
    </>
  )
}

export default AccountsReceivable
